/* eslint-disable spaced-comment */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
/* eslint-disable import/order */
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import SkeletonBox from "components/SkeletonBox";
import Search from "components/Search";
import Label from "./Label";
import Wrapper from "./Wrapper";
import MenuSidebar from "./MenuSidebar";
import titleSvc from "services/titleSvc";
import apiVersionSvc from "services/apiVersionSvc";
import menuSvc from "services/menuSvc";
import useOnMount from "utils/customHooks";
import styled from "styled-components";

const RowFlex = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

const DropdownVersion = ({ selected = { version: "No Data" }, data = [], onChange }) => {
  return (
    <div className="dropdown margin-inline-20">
      <button
        className="btn btn-secondary dropdown-toggle"
        type="button"
        id="dropdownMenuButton1"
        data-bs-toggle="dropdown"
        aria-expanded="false"
      >
        {selected?.version}
      </button>
      <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
        {data &&
          data.map((item, i) => {
            return (
              <li key={item.version}>
                <a className="dropdown-item" href="#" onClick={() => onChange(item)}>
                  {item.version}
                </a>
              </li>
            );
          })}
      </ul>
    </div>
  );
};

const NoMenu = () => {
  return <div style={{ color: "white", textAlign: "center" }}>Sorry, there is no Menu yet!</div>;
};

const SidebarList = ({ loading, error, dataVersion, dataMenu }) => {
  const history = useHistory();
  const [titleList, setTitleList] = useState();
  const [filteredTitle, setFilteredTitle] = useState();
  const [versionList, setVersionList] = useState();
  const [selectedVersion, setSelectedVersion] = useState();
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    if (dataVersion && dataVersion.length > 0 && dataMenu && dataMenu.length > 0) {
      // ser version list
      const sortedVersion = dataVersion.sort((a, b) => compare(a.createdAt, b.createdAt));
      setVersionList(sortedVersion);
      setSelectedVersion(sortedVersion[0]);

      // create new object
      const groupMenu = createGroup(dataMenu);

      // sort by number
      const sortedTitle = groupMenu
        .map((parent) => {
          parent.child.sort((a, b) => compare(a.number, b.number));
          return parent;
        })
        .sort((a, b) => compare(a.title, b.title));

      setTitleList(sortedTitle);
      setFilteredTitle(sortedTitle);
        console.log(sortedTitle);
      //redirectToMainPage(sortedTitle[0]);
    }
  }, [dataVersion, dataMenu]);

  useEffect(() => {
    if (titleList) {
      const titleByVersion = titleList.map((parent) => {
        const filteredParent = parent.child.filter((item) => {
          return (
            item.apiVersionUid === selectedVersion.id &&
            item.title?.toLowerCase().includes(searchText)
          );
        });
        return { ...parent, child: filteredParent };
      });
      setFilteredTitle(titleByVersion);
    }
  }, [selectedVersion, searchText]);

  const createGroup = (menus) => {
    const result = [];
    menus.forEach((menu) => {
      const titleObj = {
        id: menu.id,
        title: menu.title,
        number: menu.number,
        icon: menu.icon,
        child: [],
      };
      menu.titles.forEach((child) => {
        titleObj.child.push(child);
      });
      result.push(titleObj);
    });
    return result;
  };

  const compare = (a, b) => {
    if (a > b) return +1;
    if (a < b) return -1;
    return 0;
  };

  const redirectToMainPage = (parent) => {
    history.push(`/docs/${parent.id}/${parent.child[0].id}`);
  };

  if (loading) {
    return (
      <div className="margin-inline-20">
        <SkeletonBox count={4} />
      </div>
    );
  }

  if (error) {
    return <div style={{ color: "white", textAlign: "center" }}>{error}</div>;
  }

  return (
    <>
      <RowFlex>
        <Label className="margin-inline-20">API Docs</Label>
        <DropdownVersion
          selected={selectedVersion}
          data={versionList}
          onChange={(item) => setSelectedVersion(item)}
        />
      </RowFlex>
      <Search
        placeholder="Search for help..."
        className="margin-inline-20 margin-bottom-15"
        onSearch={setSearchText}
      />
      {filteredTitle ? (
        filteredTitle.map((val) => {
          return (
            <MenuSidebar
              key={val.id}
              id={val.id}
              child={val.child}
              title={val.title}
              icon={val.icon}
            />
          );
        })
      ) : (
        <NoMenu />
      )}
    </>
  );
};

const Sidebar = () => {
  const { isLoading, data, error } = useOnMount(
    () => apiVersionSvc.getAll(),
    () => menuSvc.getAll()
  );
  return (
    <Wrapper>
      <SidebarList
        loading={isLoading}
        error={error?.message}
        dataVersion={data ? data[0].data.data : []}
        dataMenu={data ? data[1].data.data : []}
      />
    </Wrapper>
  );
};

export default Sidebar;
